/* Text only reveal */
(() => {
  const BASE = "sr-reveal";
  const ACTIVE = "sr-reveal--active";

  const prefersReducedMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const inViewport = (el) => {
    const r = el.getBoundingClientRect();
    return r.top < window.innerHeight * 0.9 && r.bottom > 0;
  };

  const isMeasurable = (el) => {
    const r = el.getBoundingClientRect?.();
    return !!r && r.width > 2 && r.height > 2;
  };

  const isInsideUi = (el) =>
    el.closest("header, footer, nav, dialog, [role='dialog'], .drawer, .modal, .popup, .cart-drawer");

  let io = null;
  const getObserver = () => {
    if (prefersReducedMotion || !("IntersectionObserver" in window)) return null;
    if (io) return io;

    io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(ACTIVE);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -10% 0px" }
    );

    return io;
  };

  const tagEl = (el, variant) => {
    if (!el || el.nodeType !== 1) return;
    if (el.classList.contains(BASE)) return;
    if (isInsideUi(el)) return;
    if (!isMeasurable(el)) return;

    el.classList.add(BASE);
    if (variant) el.classList.add(variant);
  };

  const collectTargets = () => {
    const root = document.querySelector("main") || document.body;
    const sections = root.querySelectorAll('section[id^="shopify-section-"], [id^="shopify-section-"]');

    const targets = new Set();

    sections.forEach((section) => {
      if (isInsideUi(section)) return;

      const inner =
        section.querySelector(".section, .section__content, .page-width, .container, [class*='inner'], [class*='content']") ||
        section;

      // TEXT ONLY
      inner.querySelectorAll(".rte, .prose, .rich-text, [class*='text'], [class*='copy'], h1, h2, h3, h4, p, li").forEach((t) => {
        tagEl(t);
        targets.add(t);
      });
    });

    return Array.from(targets).filter((el) => el.classList.contains(BASE) && isMeasurable(el) && !isInsideUi(el));
  };

  const run = () => {
    const targets = collectTargets();

    if (!targets.length) return;

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add(ACTIVE));
      return;
    }

    const obs = getObserver();

    requestAnimationFrame(() => {
      targets.forEach((el) => {
        if (inViewport(el)) {
          el.classList.add(ACTIVE);
        } else {
          obs.observe(el);
        }
      });
    });
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();

  window.addEventListener("load", run);
  window.addEventListener("resize", () => requestAnimationFrame(run));

  document.addEventListener("shopify:section:load", run);
  document.addEventListener("shopify:section:reorder", run);
  document.addEventListener("shopify:section:select", run);

  const mo = new MutationObserver(() => requestAnimationFrame(run));
  mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ["class", "style"] });
})();